import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useFetch } from "../../custom/api";
import "react-calendar/dist/Calendar.css";
import "../../styles/Containers.css";
import "../../styles/Buttons.css";
import "../../styles/Fonts.css";
import "./styles/CalendarStyle.css";
import Navbar from "../../components/Navbar";
import TopNavbarCalen from "./components/TopNavbarCalen";
import TopNavbarBack from "../../components/TopNavbarBack";
import Week from "./components/Week";
import CalendarEmptyState from "./components/CalendarEmptyState";
import GoToTop from "../../components/GoToTop";
import { ReactComponent as AroundTW } from "../../media/around_the_world.svg";

import persian from "react-date-object/calendars/persian.js";
import persian_fa from "react-date-object/locales/persian_fa.js";
import DateObject from "react-date-object";

import LoadingPage from "../../components/LoadingPage";

function dayToWeek(day) {
  const week = [];

  const dateobject = new DateObject({
    date: day,
    locale: persian_fa,
  });

  let todayDayOfWeek = dateobject.weekDay.number;

  for (let i = todayDayOfWeek; i >= 1; i--) {
    let myDay = new DateObject({
      date: day,
      locale: persian_fa,
    }).subtract(i, "day");

    week.push(myDay);
  }

  week.push(dateobject);

  for (let i = 1; i <= 6 - todayDayOfWeek; i++) {
    let myDay = new DateObject({
      date: day,
      locale: persian_fa,
    }).add(i, "day");
    week.push(myDay);
  }

  return week;
}

function Calendarr() {
  const date = new Date();

  const { myFetch } = useFetch();
  const isLoggedIn = !!localStorage.getItem("token");
  const [day, setDay] = useState(date);
  const [week, setWeek] = useState(dayToWeek(date));
  const [activePlan, setActivePlan] = useState(null);

  useEffect(() => {
    setWeek(dayToWeek(day));
  }, [day]);

  useEffect(() => {
    if (!isLoggedIn) return;
    const fetchData = async () => {
      const resp = await myFetch(`plans`, { method: "Get" });
      const r = await resp.json();
      setActivePlan(r.active_plan);
    };
    fetchData();
  }, []);

  const Buttons = () => {
    const handlePreviousWeek = () => {
      var result = day.setDate(day.getDate() - 7);
      setDay(new Date(result));
    };

    const handleNextWeek = () => {
      var result = day.setDate(day.getDate() + 7);
      setDay(new Date(result));
    };

    return (
      <>
        <div className="">
          <Week week={week}></Week>
        </div>
        <div className="spc-between bottom6FixedPosition">
          <button onClick={handlePreviousWeek} className="rectangleSmall b-white shadow-down purple-1">
            <span className="icon-iconchevron-right heading-3 marginL10"></span>
          </button>
          <button onClick={handleNextWeek} className="rectangleSmall b-white shadow-down purple-1">
            <span className="icon-iconchevron-left heading-3 marginL10"></span>
          </button>
        </div>
      </>
    );
  };

  const LockedCalendar = () => {
    return (
      <div>
        <TopNavbarBack
          title=""
          rbuttonIcon={["icon-iconchevron-right"]}
          rbackground={["rectangle1"]}
          lbuttonIcon={["dNone"]}
          lbuttonHref={["null"]}
          lbackground={["null"]}
          className="fixedPosition"
        />
        <div className="marginTop10 marginSide14">
          <AroundTW alt="AroundTW"></AroundTW>
          <p className="rightAlign">
            برای استفاده از دستورهای غذایی بیشتر و تقویم لازمه اشتراک حرفه‌ای
            داشته باشی.
          </p>
          <div className="marginTop20 marginBottom5">
            <Link to="/subscription" className="primaryPurple">
              زیر 2 دقیقه فعالش کن
            </Link>
          </div>
        </div>
        <Navbar />
      </div>
    );
  };

  const OpenCalendar = () => {
    return (
      <div className="grey-background paddingButtom80">
        <TopNavbarCalen title="تقویم" />
        <div className="marginBottom40">
          <Buttons />
        </div>
      </div>
    );
  };

  if (!isLoggedIn) {
    return (
      <div className="paddingButtom80 grey-background">
        <TopNavbarCalen title="تقویم" />
        <CalendarEmptyState variant="guest" />
        <Navbar />
        <GoToTop />
      </div>
    );
  }

  return (
    <>
      {activePlan === null ? <LoadingPage /> : <OpenCalendar />}
      <Navbar />
      <GoToTop />
    </>
  );
}

export { dayToWeek, Calendarr };
